"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = GenericIcon;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("../../utils/utils");
function GenericIcon({
  color,
  fillColor,
  icon,
  width,
  height,
  strokeWidth,
  title
}) {
  switch (icon) {
    default:
    case "alert-circle":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "Alert Circle"), /*#__PURE__*/_react.default.createElement("path", {
        d: "M10 18.3333C14.6024 18.3333 18.3333 14.6024 18.3333 9.99999C18.3333 5.39762 14.6024 1.66666 10 1.66666C5.39763 1.66666 1.66667 5.39762 1.66667 9.99999C1.66667 14.6024 5.39763 18.3333 10 18.3333Z",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M10 6.66666V9.99999",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M10 13.3333H10.0075",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "alert-octagon":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "Alert Octagon"), /*#__PURE__*/_react.default.createElement("path", {
        d: "M6.55001 1.66666H13.45L18.3333 6.54999V13.45L13.45 18.3333H6.55001L1.66667 13.45V6.54999L6.55001 1.66666Z",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M10 6.66666V9.99999",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M10 13.3333H10.0088",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "alert-triangle":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "Alert Triangle"), /*#__PURE__*/_react.default.createElement("path", {
        d: "M8.28168 3.21668L1.22335 15C1.07782 15.252 1.00082 15.5378 1.00001 15.8288C0.999192 16.1198 1.07459 16.406 1.2187 16.6588C1.36282 16.9116 1.57062 17.1223 1.82144 17.2699C2.07226 17.4175 2.35735 17.4968 2.64835 17.5H16.765C17.056 17.4968 17.3411 17.4175 17.5919 17.2699C17.8427 17.1223 18.0505 16.9116 18.1947 16.6588C18.3388 16.406 18.4142 16.1198 18.4134 15.8288C18.4125 15.5378 18.3355 15.252 18.19 15L11.1317 3.21668C10.9831 2.97177 10.774 2.76928 10.5243 2.62875C10.2747 2.48822 9.99313 2.4144 9.70668 2.4144C9.42024 2.4144 9.13862 2.48822 8.88902 2.62875C8.63941 2.76928 8.43024 2.97177 8.28168 3.21668V3.21668Z",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M10 7.5V10.8333",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M10 14.1667H10.0088",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "anchor":
      return /*#__PURE__*/_react.default.createElement("svg", {
        fill: "none",
        viewBox: "0 0 18 18",
        width: width || 18,
        height: height || 18,
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "Anchor"), /*#__PURE__*/_react.default.createElement("g", {
        stroke: color,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: strokeWidth || 1.5
      }, /*#__PURE__*/_react.default.createElement("path", {
        d: "m9.0001 5.8c1.3255 0 2.4-1.07452 2.4-2.4s-1.0745-2.4-2.4-2.4c-1.32549 0-2.4 1.07452-2.4 2.4s1.07451 2.4 2.4 2.4z"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "m9 16.9998v-11.2"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "m3.4 9h-2.4c0 2.1217.84285 4.1566 2.34315 5.6569 1.50029 1.5002 3.53512 2.3431 5.65685 2.3431 2.1217 0 4.1566-.8429 5.6569-2.3431 1.5002-1.5003 2.3431-3.5352 2.3431-5.6569h-2.4"
      })));
    case "arrow-right-modified":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "Right Arrow"), /*#__PURE__*/_react.default.createElement("path", {
        d: "M3 9.83331H17",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M12 4L17.8333 9.83333L12 15.6667",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "bell":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "Bell"), /*#__PURE__*/_react.default.createElement("path", {
        d: "M15 6.66666C15 5.34057 14.4732 4.0688 13.5355 3.13112C12.5979 2.19344 11.3261 1.66666 10 1.66666C8.67392 1.66666 7.40215 2.19344 6.46447 3.13112C5.52678 4.0688 5 5.34057 5 6.66666C5 12.5 2.5 14.1667 2.5 14.1667H17.5C17.5 14.1667 15 12.5 15 6.66666Z",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M11.4417 17.5C11.2951 17.7526 11.0849 17.9622 10.8318 18.1079C10.5788 18.2537 10.292 18.3304 9.99999 18.3304C9.708 18.3304 9.42114 18.2537 9.16813 18.1079C8.91512 17.9622 8.70483 17.7526 8.55832 17.5",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "bookmark":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width || 14,
        height: height || 14,
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "Bookmark"), /*#__PURE__*/_react.default.createElement("path", {
        d: "M12 13.0001L7 9.66673L2 13.0001V2.33339C2 1.97977 2.15051 1.64063 2.41842 1.39059C2.68633 1.14054 3.04969 1.00006 3.42857 1.00006H10.5714C10.9503 1.00006 11.3137 1.14054 11.5816 1.39059C11.8495 1.64063 12 1.97977 12 2.33339V13.0001Z",
        stroke: color,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "book-open":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width || 17,
        height: height || 16,
        viewBox: "0 0 17 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "Open Book"), /*#__PURE__*/_react.default.createElement("path", {
        d: "M1.83203 2H5.83203C6.53927 2 7.21755 2.28095 7.71765 2.78105C8.21775 3.28115 8.4987 3.95942 8.4987 4.66667V14C8.4987 13.4696 8.28798 12.9609 7.91291 12.5858C7.53784 12.2107 7.02913 12 6.4987 12H1.83203V2Z",
        stroke: color,
        strokeWidth: strokeWidth || 1.2,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M15.1667 2H11.1667C10.4594 2 9.78115 2.28095 9.28105 2.78105C8.78095 3.28115 8.5 3.95942 8.5 4.66667V14C8.5 13.4696 8.71071 12.9609 9.08579 12.5858C9.46086 12.2107 9.96957 12 10.5 12H15.1667V2Z",
        stroke: color,
        strokeWidth: strokeWidth || 1.2,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "calculator":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width || 29,
        height: height || 28,
        viewBox: "0 0 29 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, " ", title || "Calculator"), /*#__PURE__*/_react.default.createElement("path", {
        d: "M7.5 2.91666V11.0833",
        stroke: color,
        strokeWidth: strokeWidth || 2,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M3.4166 7H11.5833",
        stroke: color,
        strokeWidth: strokeWidth || 2,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M17.4166 20.5847H25.5833",
        stroke: color,
        strokeWidth: strokeWidth || 2,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M21.4998 17.2514C21.822 17.2514 22.0832 16.9902 22.0832 16.6681C22.0832 16.3459 21.822 16.0847 21.4998 16.0847C21.1777 16.0847 20.9165 16.3459 20.9165 16.6681C20.9165 16.9902 21.1777 17.2514 21.4998 17.2514Z",
        fill: "#0B395B",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M21.4998 25.0847C21.822 25.0847 22.0832 24.8236 22.0832 24.5014C22.0832 24.1792 21.822 23.9181 21.4998 23.9181C21.1777 23.9181 20.9165 24.1792 20.9165 24.5014C20.9165 24.8236 21.1777 25.0847 21.4998 25.0847Z",
        fill: "#0B395B",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M17.4166 7H25.5833",
        stroke: color,
        strokeWidth: strokeWidth || 2,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M11 17.5L4 24.5",
        stroke: color,
        strokeWidth: strokeWidth || 2,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M4 17.5L11 24.5",
        stroke: color,
        strokeWidth: strokeWidth || 2,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "calculator-2":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 26",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "Calculator"), /*#__PURE__*/_react.default.createElement("rect", {
        x: "2",
        y: "1.5",
        width: "20",
        height: "23",
        rx: "3",
        stroke: color,
        strokeWidth: strokeWidth || 2.1,
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("line", {
        x1: "2",
        y1: "8.45",
        x2: "22",
        y2: "8.45",
        stroke: color,
        strokeWidth: strokeWidth || 2.1
      }), /*#__PURE__*/_react.default.createElement("circle", {
        cx: "7",
        cy: "12.5",
        r: "1",
        fill: fillColor || _utils.colors["orca-grey-8"]
      }), /*#__PURE__*/_react.default.createElement("circle", {
        cx: "7",
        cy: "16.5",
        r: "1",
        fill: fillColor || _utils.colors["orca-grey-8"]
      }), /*#__PURE__*/_react.default.createElement("circle", {
        cx: "7",
        cy: "20.5",
        r: "1",
        fill: fillColor || _utils.colors["orca-grey-8"]
      }), /*#__PURE__*/_react.default.createElement("circle", {
        cx: "12",
        cy: "16.5",
        r: "1",
        fill: fillColor || _utils.colors["orca-grey-8"]
      }), /*#__PURE__*/_react.default.createElement("circle", {
        cx: "12",
        cy: "12.5",
        r: "1",
        fill: fillColor || _utils.colors["orca-grey-8"]
      }), /*#__PURE__*/_react.default.createElement("circle", {
        cx: "12",
        cy: "20.5",
        r: "1",
        fill: fillColor || _utils.colors["orca-grey-8"]
      }), /*#__PURE__*/_react.default.createElement("circle", {
        cx: "17",
        cy: "12.5",
        r: "1",
        fill: fillColor || _utils.colors["orca-grey-8"]
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M17 16.5V20.5",
        stroke: color,
        strokeWidth: strokeWidth || 2.1,
        strokeLinecap: "round"
      }));
    case "calendar":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "Calendar"), /*#__PURE__*/_react.default.createElement("path", {
        d: "M15.8333 3.33334H4.16667C3.24619 3.33334 2.5 4.07954 2.5 5.00001V16.6667C2.5 17.5872 3.24619 18.3333 4.16667 18.3333H15.8333C16.7538 18.3333 17.5 17.5872 17.5 16.6667V5.00001C17.5 4.07954 16.7538 3.33334 15.8333 3.33334Z",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M13.3333 1.66666V4.99999",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M6.66667 1.66666V4.99999",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M2.5 8.33334H17.5",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "check":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "Checkmark"), /*#__PURE__*/_react.default.createElement("path", {
        d: "M16.6667 5L7.50001 14.1667L3.33334 10",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "chevron-down":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "Down Chevron"), /*#__PURE__*/_react.default.createElement("path", {
        d: "M5 7.5L10 12.5L15 7.5",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "chevron-left":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "Left Chevron"), /*#__PURE__*/_react.default.createElement("path", {
        d: "M12.5 15L7.5 10L12.5 5",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "chevron-right":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "Right Chevron"), /*#__PURE__*/_react.default.createElement("path", {
        d: "M7.5 15L12.5 10L7.5 5",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "chevron-up":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "Up Chevron"), /*#__PURE__*/_react.default.createElement("path", {
        d: "M15 12.5L10 7.5L5 12.5",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "chevrons-left":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width || 24,
        height: height || 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "Left Chevrons"), /*#__PURE__*/_react.default.createElement("path", {
        d: "M11 17L6 12L11 7",
        stroke: color,
        strokeWidth: strokeWidth || 2,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M18 17L13 12L18 7",
        stroke: color,
        strokeWidth: strokeWidth || 2,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "chevrons-right":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width || 24,
        height: height || 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "Right Chevrons"), /*#__PURE__*/_react.default.createElement("path", {
        d: "M13 17L18 12L13 7",
        stroke: color,
        strokeWidth: strokeWidth || 2,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M6 17L11 12L6 7",
        stroke: color,
        strokeWidth: strokeWidth || 2,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "clipboard":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "Clipboard"), /*#__PURE__*/_react.default.createElement("path", {
        d: "M13.3335 3.33333H15.0002C15.4422 3.33333 15.8661 3.50893 16.1787 3.82149C16.4912 4.13405 16.6668 4.55797 16.6668 5V16.6667C16.6668 17.1087 16.4912 17.5326 16.1787 17.8452C15.8661 18.1577 15.4422 18.3333 15.0002 18.3333H5.00016C4.55814 18.3333 4.13421 18.1577 3.82165 17.8452C3.50909 17.5326 3.3335 17.1087 3.3335 16.6667V5C3.3335 4.55797 3.50909 4.13405 3.82165 3.82149C4.13421 3.50893 4.55814 3.33333 5.00016 3.33333H6.66683",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M12.4998 1.66667H7.49984C7.0396 1.66667 6.6665 2.03976 6.6665 2.5V4.16667C6.6665 4.62691 7.0396 5 7.49984 5H12.4998C12.9601 5 13.3332 4.62691 13.3332 4.16667V2.5C13.3332 2.03976 12.9601 1.66667 12.4998 1.66667Z",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "clock":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "Clock"), /*#__PURE__*/_react.default.createElement("g", {
        clipPath: "url(#clip0_85_4734)"
      }, /*#__PURE__*/_react.default.createElement("path", {
        d: "M7.99992 14.6667C11.6818 14.6667 14.6666 11.6819 14.6666 8.00004C14.6666 4.31814 11.6818 1.33337 7.99992 1.33337C4.31802 1.33337 1.33325 4.31814 1.33325 8.00004C1.33325 11.6819 4.31802 14.6667 7.99992 14.6667Z",
        stroke: color,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M8 4V8L10.6667 9.33333",
        stroke: color,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
        id: "clip0_85_4734"
      }, /*#__PURE__*/_react.default.createElement("rect", {
        width: "16",
        height: "16",
        fill: "white"
      }))));
    case "cpu":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width || 14,
        height: height || 14,
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "CPU"), /*#__PURE__*/_react.default.createElement("g", {
        clipPath: "url(#clip0_737_1216)"
      }, /*#__PURE__*/_react.default.createElement("path", {
        d: "M10.5 2.33333H3.50004C2.85571 2.33333 2.33337 2.85566 2.33337 3.49999V10.5C2.33337 11.1443 2.85571 11.6667 3.50004 11.6667H10.5C11.1444 11.6667 11.6667 11.1443 11.6667 10.5V3.49999C11.6667 2.85566 11.1444 2.33333 10.5 2.33333Z",
        stroke: color,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M8.75 5.25H5.25V8.75H8.75V5.25Z",
        stroke: color,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M5.25 0.583328V2.33333",
        stroke: color,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M8.75 0.583328V2.33333",
        stroke: color,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M5.25 11.6667V13.4167",
        stroke: color,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M8.75 11.6667V13.4167",
        stroke: color,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M11.6666 5.25H13.4166",
        stroke: color,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M11.6666 8.16667H13.4166",
        stroke: color,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M0.583374 5.25H2.33337",
        stroke: color,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M0.583374 8.16667H2.33337",
        stroke: color,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
        id: "clip0_737_1216"
      }, /*#__PURE__*/_react.default.createElement("rect", {
        width: "14",
        height: "14",
        fill: "white"
      }))));
    case "coffee":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "Coffee"), /*#__PURE__*/_react.default.createElement("path", {
        d: "M15 6.66666H15.8333C16.7174 6.66666 17.5652 7.01785 18.1904 7.64297C18.8155 8.26809 19.1667 9.11593 19.1667 9.99999C19.1667 10.884 18.8155 11.7319 18.1904 12.357C17.5652 12.9821 16.7174 13.3333 15.8333 13.3333H15",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M1.66669 6.66666H15V14.1667C15 15.0507 14.6488 15.8986 14.0237 16.5237C13.3986 17.1488 12.5507 17.5 11.6667 17.5H5.00002C4.11597 17.5 3.26812 17.1488 2.643 16.5237C2.01788 15.8986 1.66669 15.0507 1.66669 14.1667V6.66666Z",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M5 0.833344V3.33334",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M8.33337 0.833344V3.33334",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M11.6667 0.833344V3.33334",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "compass":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "Compass"), /*#__PURE__*/_react.default.createElement("path", {
        d: "M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18Z",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M12.6667 7.33325L11.3334 11.3333L7.33337 12.6666L8.66671 8.66659L12.6667 7.33325Z",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "dollar-sign":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "Dollar Sign"), /*#__PURE__*/_react.default.createElement("g", {
        id: "dollar-sign 1",
        clipPath: "url(#clip0_1103_535)"
      }, /*#__PURE__*/_react.default.createElement("path", {
        id: "Vector",
        d: "M8 0.666626V15.3333",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        id: "Vector_2",
        d: "M11.3333 3.33337H6.33333C5.71449 3.33337 5.121 3.57921 4.68342 4.01679C4.24583 4.45438 4 5.04787 4 5.66671C4 6.28555 4.24583 6.87904 4.68342 7.31662C5.121 7.75421 5.71449 8.00004 6.33333 8.00004H9.66667C10.2855 8.00004 10.879 8.24587 11.3166 8.68346C11.7542 9.12104 12 9.71454 12 10.3334C12 10.9522 11.7542 11.5457 11.3166 11.9833C10.879 12.4209 10.2855 12.6667 9.66667 12.6667H4",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
        id: "clip0_1103_535"
      }, /*#__PURE__*/_react.default.createElement("rect", {
        width: "16",
        height: "16",
        fill: "white"
      }))));
    case "download":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "Download"), /*#__PURE__*/_react.default.createElement("path", {
        d: "M17.5 12.5V15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V12.5",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M5.8335 8.33333L10.0002 12.5L14.1668 8.33333",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M10 12.5V2.5",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "edit":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width || 16,
        height: width || 16,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "Edit"), /*#__PURE__*/_react.default.createElement("g", {
        clipPath: "url(#clip0_738_3684)"
      }, /*#__PURE__*/_react.default.createElement("path", {
        d: "M7.33337 2.66675H2.66671C2.31309 2.66675 1.97395 2.80722 1.7239 3.05727C1.47385 3.30732 1.33337 3.64646 1.33337 4.00008V13.3334C1.33337 13.687 1.47385 14.0262 1.7239 14.2762C1.97395 14.5263 2.31309 14.6667 2.66671 14.6667H12C12.3537 14.6667 12.6928 14.5263 12.9428 14.2762C13.1929 14.0262 13.3334 13.687 13.3334 13.3334V8.66675",
        stroke: color,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M12.3334 1.66665C12.5986 1.40144 12.9583 1.25244 13.3334 1.25244C13.7084 1.25244 14.0682 1.40144 14.3334 1.66665C14.5986 1.93187 14.7476 2.29158 14.7476 2.66665C14.7476 3.04173 14.5986 3.40144 14.3334 3.66665L8.00004 9.99999L5.33337 10.6667L6.00004 7.99999L12.3334 1.66665Z",
        stroke: "black",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
        id: "clip0_738_3684"
      }, /*#__PURE__*/_react.default.createElement("rect", {
        width: "16",
        height: "16",
        fill: "white"
      }))));
    case "edit-2":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "Edit"), /*#__PURE__*/_react.default.createElement("path", {
        d: "M16 1.82843C16.2626 1.56578 16.5744 1.35744 16.9176 1.2153C17.2608 1.07316 17.6286 1 18 1C18.3714 1 18.7392 1.07316 19.0824 1.2153C19.4256 1.35744 19.7374 1.56578 20 1.82843C20.2626 2.09107 20.471 2.40287 20.6131 2.74603C20.7553 3.0892 20.8284 3.45699 20.8284 3.82843C20.8284 4.19986 20.7553 4.56766 20.6131 4.91082C20.471 5.25398 20.2626 5.56578 20 5.82843L6.5 19.3284L1 20.8284L2.5 15.3284L16 1.82843Z",
        stroke: color,
        strokeWidth: strokeWidth || 2,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "edit-3":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "Edit"), /*#__PURE__*/_react.default.createElement("g", {
        id: "edit-3 1"
      }, /*#__PURE__*/_react.default.createElement("path", {
        id: "Vector",
        d: "M8 13.3334H14",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        id: "Vector_2",
        d: "M11 2.33328C11.2652 2.06806 11.6249 1.91907 12 1.91907C12.1857 1.91907 12.3696 1.95565 12.5412 2.02672C12.7128 2.09779 12.8687 2.20196 13 2.33328C13.1313 2.4646 13.2355 2.6205 13.3066 2.79208C13.3776 2.96367 13.4142 3.14756 13.4142 3.33328C13.4142 3.519 13.3776 3.7029 13.3066 3.87448C13.2355 4.04606 13.1313 4.20196 13 4.33328L4.66667 12.6666L2 13.3333L2.66667 10.6666L11 2.33328Z",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      })));
    case "external-link":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "External Link"), /*#__PURE__*/_react.default.createElement("path", {
        d: "M15 10.8333V15.8333C15 16.2754 14.8244 16.6993 14.5118 17.0118C14.1993 17.3244 13.7754 17.5 13.3333 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V6.66667C2.5 6.22464 2.67559 5.80072 2.98816 5.48816C3.30072 5.17559 3.72464 5 4.16667 5H9.16667",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M12.5 2.5H17.5V7.5",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M8.33333 11.6667L17.5 2.5",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "file-text":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width || 14,
        height: width || 14,
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "File Text"), /*#__PURE__*/_react.default.createElement("path", {
        d: "M8.16665 1.16667H3.49998C3.19056 1.16667 2.89381 1.28959 2.67502 1.50838C2.45623 1.72717 2.33331 2.02392 2.33331 2.33334V11.6667C2.33331 11.9761 2.45623 12.2728 2.67502 12.4916C2.89381 12.7104 3.19056 12.8333 3.49998 12.8333H10.5C10.8094 12.8333 11.1061 12.7104 11.3249 12.4916C11.5437 12.2728 11.6666 11.9761 11.6666 11.6667V4.66667L8.16665 1.16667Z",
        stroke: color,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M8.16669 1.16667V4.66667H11.6667",
        stroke: color,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M9.33335 7.58333H4.66669",
        stroke: color,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M9.33335 9.91667H4.66669",
        stroke: color,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M5.83335 5.25H5.25002H4.66669",
        stroke: color,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "globe":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "Globe"), /*#__PURE__*/_react.default.createElement("path", {
        d: "M10 18.3333C14.6024 18.3333 18.3333 14.6023 18.3333 9.99996C18.3333 5.39759 14.6024 1.66663 10 1.66663C5.39763 1.66663 1.66667 5.39759 1.66667 9.99996C1.66667 14.6023 5.39763 18.3333 10 18.3333Z",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M1.66667 10H18.3333",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M10 1.66663C12.0844 3.94859 13.269 6.90999 13.3333 9.99996C13.269 13.0899 12.0844 16.0513 10 18.3333C7.9156 16.0513 6.73104 13.0899 6.66667 9.99996C6.73104 6.90999 7.9156 3.94859 10 1.66663V1.66663Z",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "heart":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "Heart"), /*#__PURE__*/_react.default.createElement("path", {
        d: "M17.3667 3.84166C16.941 3.41583 16.4357 3.07803 15.8795 2.84757C15.3232 2.6171 14.7271 2.49847 14.125 2.49847C13.5229 2.49847 12.9268 2.6171 12.3705 2.84757C11.8143 3.07803 11.309 3.41583 10.8833 3.84166L10 4.725L9.11666 3.84166C8.25692 2.98192 7.09086 2.49892 5.875 2.49892C4.65914 2.49892 3.49307 2.98192 2.63333 3.84166C1.77359 4.70141 1.29059 5.86747 1.29059 7.08333C1.29059 8.29919 1.77359 9.46525 2.63333 10.325L3.51666 11.2083L10 17.6917L16.4833 11.2083L17.3667 10.325C17.7925 9.89937 18.1303 9.39401 18.3608 8.83779C18.5912 8.28158 18.7099 7.6854 18.7099 7.08333C18.7099 6.48126 18.5912 5.88508 18.3608 5.32887C18.1303 4.77265 17.7925 4.26729 17.3667 3.84166V3.84166Z",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "help-circle":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "Help Circle"), /*#__PURE__*/_react.default.createElement("path", {
        d: "M9.99999 18.3333C14.6024 18.3333 18.3333 14.6024 18.3333 9.99999C18.3333 5.39762 14.6024 1.66666 9.99999 1.66666C5.39762 1.66666 1.66666 5.39762 1.66666 9.99999C1.66666 14.6024 5.39762 18.3333 9.99999 18.3333Z",
        stroke: color,
        fill: fillColor || "#fff",
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M7.57501 7.50002C7.77093 6.94307 8.15764 6.47344 8.66664 6.17429C9.17564 5.87515 9.77409 5.7658 10.356 5.86561C10.9379 5.96542 11.4657 6.26795 11.8459 6.71962C12.2261 7.17129 12.4342 7.74295 12.4333 8.33335C12.4333 10 9.93335 10.8334 9.93335 10.8334",
        stroke: color,
        fill: fillColor || "#fff",
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M10 14.1667H10.0088",
        stroke: color,
        fill: fillColor || "#fff",
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "home":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "Home"), /*#__PURE__*/_react.default.createElement("path", {
        d: "M2.5 7.49999L10 1.66666L17.5 7.49999V16.6667C17.5 17.1087 17.3244 17.5326 17.0118 17.8452C16.6993 18.1577 16.2754 18.3333 15.8333 18.3333H4.16667C3.72464 18.3333 3.30072 18.1577 2.98816 17.8452C2.67559 17.5326 2.5 17.1087 2.5 16.6667V7.49999Z",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M7.5 18.3333V10H12.5V18.3333",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "info":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "Info"), /*#__PURE__*/_react.default.createElement("path", {
        d: "M9.99999 18.3333C14.6024 18.3333 18.3333 14.6024 18.3333 9.99999C18.3333 5.39762 14.6024 1.66666 9.99999 1.66666C5.39762 1.66666 1.66666 5.39762 1.66666 9.99999C1.66666 14.6024 5.39762 18.3333 9.99999 18.3333Z",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M10 13.3333V10",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M10 6.66666H10.0088",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "key":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "Key"), /*#__PURE__*/_react.default.createElement("path", {
        d: "M12.9167 6.24999L15.8334 3.33332M17.5 1.66666L15.8334 3.33332L17.5 1.66666ZM9.49171 9.67499C9.922 10.0995 10.264 10.605 10.4982 11.1623C10.7323 11.7196 10.8539 12.3177 10.8559 12.9222C10.8579 13.5267 10.7404 14.1256 10.51 14.6844C10.2796 15.2433 9.94093 15.751 9.5135 16.1784C9.08607 16.6059 8.57831 16.9445 8.01946 17.1749C7.46062 17.4053 6.86171 17.5229 6.25724 17.5208C5.65277 17.5188 5.05467 17.3972 4.49737 17.1631C3.94008 16.929 3.4346 16.5869 3.01005 16.1567C2.17515 15.2922 1.71318 14.1345 1.72362 12.9327C1.73407 11.731 2.21609 10.5814 3.06588 9.73165C3.91566 8.88187 5.06522 8.39984 6.26696 8.3894C7.46869 8.37896 8.62645 8.84093 9.49088 9.67582L9.49171 9.67499ZM9.49171 9.67499L12.9167 6.24999L9.49171 9.67499ZM12.9167 6.24999L15.4167 8.74999L18.3334 5.83332L15.8334 3.33332L12.9167 6.24999Z",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "layout":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "Layout"), /*#__PURE__*/_react.default.createElement("path", {
        d: "M15.8333 2.5H4.16667C3.24619 2.5 2.5 3.24619 2.5 4.16667V15.8333C2.5 16.7538 3.24619 17.5 4.16667 17.5H15.8333C16.7538 17.5 17.5 16.7538 17.5 15.8333V4.16667C17.5 3.24619 16.7538 2.5 15.8333 2.5Z",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M2.5 7.5H17.5",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M7.5 17.5V7.5",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "life-buoy":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width || 14,
        height: height || 14,
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "Life Buoy"), /*#__PURE__*/_react.default.createElement("path", {
        d: "M6.83333 9.33335C8.122 9.33335 9.16667 8.28868 9.16667 7.00002C9.16667 5.71136 8.122 4.66669 6.83333 4.66669C5.54467 4.66669 4.5 5.71136 4.5 7.00002C4.5 8.28868 5.54467 9.33335 6.83333 9.33335Z",
        stroke: color,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M8.48438 8.65094L10.9577 11.1243",
        stroke: color,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M2.70947 11.1243L5.18281 8.65094",
        stroke: color,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M6.83333 12.8334C10.055 12.8334 12.6667 10.2217 12.6667 7.00002C12.6667 3.77836 10.055 1.16669 6.83333 1.16669C3.61167 1.16669 1 3.77836 1 7.00002C1 10.2217 3.61167 12.8334 6.83333 12.8334Z",
        stroke: color,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M2.70947 2.87592L5.18281 5.34925",
        stroke: color,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M8.48438 5.34925L10.9577 2.87592",
        stroke: color,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M8.48438 5.34927L10.5435 3.2901",
        stroke: color,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "link":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "Link"), /*#__PURE__*/_react.default.createElement("g", {
        clipPath: "url(#clip0_1645_3869)"
      }, /*#__PURE__*/_react.default.createElement("path", {
        d: "M8.3335 10.8333C8.69137 11.3118 9.14796 11.7076 9.67229 11.9941C10.1966 12.2806 10.7764 12.4509 11.3724 12.4936C11.9683 12.5363 12.5665 12.4503 13.1263 12.2415C13.6861 12.0327 14.1944 11.7059 14.6168 11.2833L17.1168 8.78333C17.8758 7.99749 18.2958 6.94498 18.2863 5.85249C18.2768 4.76 17.8386 3.71495 17.0661 2.94242C16.2935 2.16989 15.2485 1.73168 14.156 1.72219C13.0635 1.71269 12.011 2.13267 11.2252 2.89166L9.79183 4.31666",
        stroke: color,
        strokeWidth: strokeWidth || 2,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M11.6668 9.16667C11.309 8.68823 10.8524 8.29235 10.328 8.00588C9.80371 7.71942 9.22391 7.54907 8.62796 7.50639C8.03201 7.46371 7.43384 7.54969 6.87405 7.75851C6.31425 7.96734 5.8059 8.29411 5.3835 8.71667L2.8835 11.2167C2.12451 12.0025 1.70453 13.055 1.71402 14.1475C1.72352 15.24 2.16172 16.285 2.93426 17.0576C3.70679 17.8301 4.75184 18.2683 5.84433 18.2778C6.93681 18.2873 7.98932 17.8673 8.77517 17.1083L10.2002 15.6833",
        stroke: color,
        strokeWidth: strokeWidth || 2,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
        id: "clip0_1645_3869"
      }, /*#__PURE__*/_react.default.createElement("rect", {
        width: "20",
        height: "20",
        fill: "white"
      }))));
    case "lock":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width || 20,
        height: height || 22,
        viewBox: "0 0 20 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "Lock"), /*#__PURE__*/_react.default.createElement("path", {
        d: "M17 10H3C1.89543 10 1 10.8954 1 12V19C1 20.1046 1.89543 21 3 21H17C18.1046 21 19 20.1046 19 19V12C19 10.8954 18.1046 10 17 10Z",
        stroke: color,
        strokeWidth: strokeWidth || 2,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M5 10V6C5 4.67392 5.52678 3.40215 6.46447 2.46447C7.40215 1.52678 8.67392 1 10 1C11.3261 1 12.5979 1.52678 13.5355 2.46447C14.4732 3.40215 15 4.67392 15 6V10",
        stroke: color,
        strokeWidth: strokeWidth || 2,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "mail":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "Mail"), /*#__PURE__*/_react.default.createElement("path", {
        d: "M3.33334 3.33334H16.6667C17.5833 3.33334 18.3333 4.08334 18.3333 5.00001V15C18.3333 15.9167 17.5833 16.6667 16.6667 16.6667H3.33334C2.41667 16.6667 1.66667 15.9167 1.66667 15V5.00001C1.66667 4.08334 2.41667 3.33334 3.33334 3.33334Z",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M18.3333 5L10 10.8333L1.66667 5",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "map-pin":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "Map pin"), /*#__PURE__*/_react.default.createElement("path", {
        d: "M17.0454 8.52272C17.0454 13.9848 10.0227 18.6666 10.0227 18.6666C10.0227 18.6666 3 13.9848 3 8.52272C3 6.66018 3.73989 4.87392 5.05691 3.55691C6.37392 2.23989 8.16018 1.5 10.0227 1.5C11.8853 1.5 13.6715 2.23989 14.9885 3.55691C16.3055 4.87392 17.0454 6.66018 17.0454 8.52272Z",
        stroke: color,
        strokeWidth: strokeWidth || 1.40454,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M10.0227 10.8636C11.3156 10.8636 12.3636 9.81558 12.3636 8.52273C12.3636 7.22988 11.3156 6.18182 10.0227 6.18182C8.72988 6.18182 7.68182 7.22988 7.68182 8.52273C7.68182 9.81558 8.72988 10.8636 10.0227 10.8636Z",
        stroke: color,
        strokeWidth: strokeWidth || 1.40454,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "megaphone":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "Megaphone"), /*#__PURE__*/_react.default.createElement("path", {
        d: "M15.8682 2.70697C15.8682 2.28772 15.3832 2.05463 15.0558 2.31653L10.5233 5.94252H2.66669C2.1144 5.94252 1.66669 6.39024 1.66669 6.94252V11.3563C1.66669 11.9086 2.1144 12.3563 2.66669 12.3563H10.5233L15.0558 15.9823C15.3832 16.2442 15.8682 16.0111 15.8682 15.5919V2.70697Z",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M2 12V17.8881H5.05386L4.36669 12",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M15.9435 6.74509C16.5924 6.74509 18 7.39403 18 9.3819C18 11.3698 16.5924 11.9367 15.9435 11.9367",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "message-circle":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "Message Bubble"), /*#__PURE__*/_react.default.createElement("path", {
        d: "M17.5 9.58333C17.5029 10.6832 17.2459 11.7682 16.75 12.75C16.162 13.9264 15.2581 14.916 14.1395 15.6077C13.021 16.2995 11.7319 16.6662 10.4167 16.6667C9.31678 16.6695 8.23176 16.4126 7.25 15.9167L2.5 17.5L4.08333 12.75C3.58744 11.7682 3.33047 10.6832 3.33333 9.58333C3.33384 8.26812 3.70051 6.97904 4.39227 5.86045C5.08402 4.74187 6.07355 3.83797 7.25 3.24999C8.23176 2.7541 9.31678 2.49713 10.4167 2.49999H10.8333C12.5703 2.59582 14.2109 3.32896 15.441 4.55904C16.671 5.78912 17.4042 7.4297 17.5 9.16666V9.58333Z",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "message-square":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width || 15,
        height: height || 16,
        viewBox: "0 0 15 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "Message Square"), /*#__PURE__*/_react.default.createElement("path", {
        d: "M12.5 9.75006C12.5 10.0595 12.3771 10.3562 12.1583 10.575C11.9395 10.7938 11.6428 10.9167 11.3333 10.9167H4.33333L2 13.2501V3.91673C2 3.60731 2.12292 3.31056 2.34171 3.09177C2.5605 2.87298 2.85725 2.75006 3.16667 2.75006H11.3333C11.6428 2.75006 11.9395 2.87298 12.1583 3.09177C12.3771 3.31056 12.5 3.60731 12.5 3.91673V9.75006Z",
        stroke: color,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "mic":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "Mic"), /*#__PURE__*/_react.default.createElement("path", {
        d: "M10 0.833344C9.33696 0.833344 8.70107 1.09674 8.23223 1.56558C7.76339 2.03442 7.5 2.6703 7.5 3.33334V10C7.5 10.6631 7.76339 11.2989 8.23223 11.7678C8.70107 12.2366 9.33696 12.5 10 12.5C10.663 12.5 11.2989 12.2366 11.7678 11.7678C12.2366 11.2989 12.5 10.6631 12.5 10V3.33334C12.5 2.6703 12.2366 2.03442 11.7678 1.56558C11.2989 1.09674 10.663 0.833344 10 0.833344V0.833344Z",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M15.8334 8.33334V10C15.8334 11.5471 15.2188 13.0308 14.1248 14.1248C13.0308 15.2188 11.5471 15.8333 10 15.8333C8.45292 15.8333 6.96919 15.2188 5.87523 14.1248C4.78127 13.0308 4.16669 11.5471 4.16669 10V8.33334",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M10 15.8333V19.1667",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M6.66669 19.1667H13.3334",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "minimize-2":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "Minimize"), /*#__PURE__*/_react.default.createElement("path", {
        d: "M2 12H8V18",
        stroke: color,
        strokeWidth: strokeWidth || 2,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M18 8H12V2",
        stroke: color,
        strokeWidth: strokeWidth || 2,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M12 8L19 1",
        stroke: color,
        strokeWidth: strokeWidth || 2,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M1 19L8 12",
        strokeWidth: strokeWidth || 2,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "monitor":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "Monitor"), /*#__PURE__*/_react.default.createElement("path", {
        d: "M16.6667 2.5H3.33335C2.41288 2.5 1.66669 3.24619 1.66669 4.16667V12.5C1.66669 13.4205 2.41288 14.1667 3.33335 14.1667H16.6667C17.5872 14.1667 18.3334 13.4205 18.3334 12.5V4.16667C18.3334 3.24619 17.5872 2.5 16.6667 2.5Z",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M6.66669 17.5H13.3334",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M10 14.1667V17.5",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "mountain":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 18 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "Mountain"), /*#__PURE__*/_react.default.createElement("path", {
        d: "M1 15.5685L5.22294 7.87636L7.14378 10.9611",
        stroke: color,
        strokeWidth: strokeWidth || 1.2,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M5.99688 8.96658L9.02529 4L13.1995 11.5861L14.4764 10.5817L17.0001 15.5887H1.01685",
        stroke: color,
        strokeWidth: strokeWidth || 1.2,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "paperclip":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "Paperclip"), /*#__PURE__*/_react.default.createElement("path", {
        d: "M17.8666 9.20835L10.2083 16.8667C9.27011 17.8049 7.99763 18.332 6.67081 18.332C5.34399 18.332 4.07151 17.8049 3.13331 16.8667C2.19511 15.9285 1.66803 14.656 1.66803 13.3292C1.66803 12.0024 2.19511 10.7299 3.13331 9.79168L10.7916 2.13335C11.4171 1.50788 12.2654 1.15649 13.15 1.15649C14.0345 1.15649 14.8828 1.50788 15.5083 2.13335C16.1338 2.75882 16.4852 3.60713 16.4852 4.49168C16.4852 5.37623 16.1338 6.22455 15.5083 6.85002L7.84164 14.5083C7.52891 14.8211 7.10475 14.9968 6.66248 14.9968C6.2202 14.9968 5.79604 14.8211 5.48331 14.5083C5.17058 14.1956 4.99488 13.7715 4.99488 13.3292C4.99488 12.8869 5.17058 12.4627 5.48331 12.15L12.5583 5.08335",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "pen-tool":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width || 14,
        height: height || 14,
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "Pen Tool"), /*#__PURE__*/_react.default.createElement("path", {
        d: "M6.99994 11.2001L11.1999 7.00005L12.9999 8.80005L8.79994 13.0001L6.99994 11.2001Z",
        stroke: color,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M10.6 7.60007L9.70001 3.10006L1 1.00006L3.1 9.70008L7.60001 10.6001L10.6 7.60007Z",
        stroke: color,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M1 1.00006L5.55161 5.55167",
        stroke: color,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M6.39992 7.60005C7.06267 7.60005 7.59992 7.06279 7.59992 6.40004C7.59992 5.7373 7.06267 5.20004 6.39992 5.20004C5.73718 5.20004 5.19992 5.7373 5.19992 6.40004C5.19992 7.06279 5.73718 7.60005 6.39992 7.60005Z",
        stroke: color,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "percent":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "Percent"), /*#__PURE__*/_react.default.createElement("path", {
        d: "M15.8333 4.16666L4.16667 15.8333",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M5.41666 7.50001C6.56725 7.50001 7.49999 6.56727 7.49999 5.41668C7.49999 4.26608 6.56725 3.33334 5.41666 3.33334C4.26607 3.33334 3.33333 4.26608 3.33333 5.41668C3.33333 6.56727 4.26607 7.50001 5.41666 7.50001Z",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M14.5833 16.6667C15.7339 16.6667 16.6667 15.7339 16.6667 14.5833C16.6667 13.4327 15.7339 12.5 14.5833 12.5C13.4327 12.5 12.5 13.4327 12.5 14.5833C12.5 15.7339 13.4327 16.6667 14.5833 16.6667Z",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "phone":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "Phone"), /*#__PURE__*/_react.default.createElement("path", {
        d: "M18.3333 14.1V16.6C18.3343 16.8321 18.2867 17.0618 18.1938 17.2745C18.1008 17.4871 17.9644 17.678 17.7934 17.8349C17.6224 17.9918 17.4205 18.1112 17.2006 18.1856C16.9808 18.26 16.7478 18.2876 16.5167 18.2667C13.9524 17.988 11.4892 17.1118 9.32499 15.7083C7.31152 14.4289 5.60444 12.7218 4.32499 10.7083C2.91664 8.53435 2.0402 6.05917 1.76666 3.48334C1.74583 3.2529 1.77322 3.02064 1.84708 2.80136C1.92093 2.58208 2.03963 2.38058 2.19563 2.20969C2.35163 2.0388 2.5415 1.90227 2.75315 1.80878C2.96481 1.71529 3.19361 1.66689 3.42499 1.66668H5.92499C6.32941 1.6627 6.72149 1.80591 7.02813 2.06962C7.33477 2.33333 7.53506 2.69955 7.59166 3.10001C7.69718 3.90006 7.89287 4.68562 8.17499 5.44168C8.28711 5.73995 8.31138 6.0641 8.24491 6.37574C8.17845 6.68738 8.02405 6.97344 7.79999 7.20001L6.74166 8.25834C7.92796 10.3446 9.65537 12.072 11.7417 13.2583L12.8 12.2C13.0266 11.976 13.3126 11.8216 13.6243 11.7551C13.9359 11.6886 14.2601 11.7129 14.5583 11.825C15.3144 12.1071 16.0999 12.3028 16.9 12.4083C17.3048 12.4655 17.6745 12.6693 17.9388 12.9813C18.203 13.2932 18.3435 13.6913 18.3333 14.1Z",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "play-circle":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "Play Circle"), /*#__PURE__*/_react.default.createElement("path", {
        d: "M9.99999 18.3333C14.6024 18.3333 18.3333 14.6024 18.3333 9.99999C18.3333 5.39762 14.6024 1.66666 9.99999 1.66666C5.39762 1.66666 1.66666 5.39762 1.66666 9.99999C1.66666 14.6024 5.39762 18.3333 9.99999 18.3333Z",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M8.33334 6.66666L13.3333 9.99999L8.33334 13.3333V6.66666Z",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "plus-sign":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "Plus sign"), /*#__PURE__*/_react.default.createElement("path", {
        d: "M9.99999 2.92893V17.0711",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M2.92892 10H17.0711",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "qr-code":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "QR Code"), /*#__PURE__*/_react.default.createElement("path", {
        d: "M3.5 3H9.5V1H3.5V3ZM9.5 3V9H11.5V3H9.5ZM9.5 9H3.5V11H9.5V9ZM3.5 9V3H1.5V9H3.5ZM3.5 9H1.5C1.5 10.1046 2.39543 11 3.5 11V9ZM9.5 9V11C10.6046 11 11.5 10.1046 11.5 9H9.5ZM9.5 3H11.5C11.5 1.89543 10.6046 1 9.5 1V3ZM3.5 1C2.39543 1 1.5 1.89543 1.5 3H3.5V1Z",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M14.5 3C14.5 2.44772 14.9477 2 15.5 2H21.5C22.0523 2 22.5 2.44772 22.5 3V9C22.5 9.55228 22.0523 10 21.5 10H15.5C14.9477 10 14.5 9.55228 14.5 9V3Z",
        stroke: color,
        strokeWidth: strokeWidth || 2,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M3.5 15H9.5V13H3.5V15ZM9.5 15V21H11.5V15H9.5ZM9.5 21H3.5V23H9.5V21ZM3.5 21V15H1.5V21H3.5ZM3.5 21H1.5C1.5 22.1046 2.39543 23 3.5 23V21ZM9.5 21V23C10.6046 23 11.5 22.1046 11.5 21H9.5ZM9.5 15H11.5C11.5 13.8954 10.6046 13 9.5 13V15ZM3.5 13C2.39543 13 1.5 13.8954 1.5 15H3.5V13Z",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M6.5 17C5.94772 17 5.5 17.4477 5.5 18C5.5 18.5523 5.94772 19 6.5 19V17ZM6.51 19C7.06229 19 7.51 18.5523 7.51 18C7.51 17.4477 7.06229 17 6.51 17V19ZM6.5 19H6.51V17H6.5V19Z",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M21.5 14.005C21.5 14.5573 21.9477 15.005 22.5 15.005C23.0523 15.005 23.5 14.5573 23.5 14.005L21.5 14.005ZM23.5 13.995C23.5 13.4427 23.0523 12.995 22.5 12.995C21.9477 12.995 21.5 13.4427 21.5 13.995L23.5 13.995ZM23.5 14.005L23.5 13.995L21.5 13.995L21.5 14.005L23.5 14.005Z",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M6.5 5C5.94772 5 5.5 5.44772 5.5 6C5.5 6.55228 5.94772 7 6.5 7V5ZM6.51 7C7.06229 7 7.51 6.55228 7.51 6C7.51 5.44772 7.06229 5 6.51 5V7ZM6.5 7H6.51V5H6.5V7Z",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M18.5 5C17.9477 5 17.5 5.44772 17.5 6C17.5 6.55228 17.9477 7 18.5 7V5ZM18.51 7C19.0623 7 19.51 6.55228 19.51 6C19.51 5.44772 19.0623 5 18.51 5V7ZM18.5 7H18.51V5H18.5V7Z",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M18.5 22L21.5 22C22.0523 22 22.5 21.5523 22.5 21L22.5 18",
        stroke: color,
        strokeWidth: strokeWidth || 2,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M18.505 18L18.505 15C18.505 14.4477 18.0573 14 17.505 14L14.505 14",
        stroke: color,
        strokeWidth: strokeWidth || 2,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M14.5 18V22",
        stroke: color,
        strokeWidth: strokeWidth || 2,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "search":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "Search"), /*#__PURE__*/_react.default.createElement("path", {
        d: "M9.16667 15.8333C12.8486 15.8333 15.8333 12.8486 15.8333 9.16667C15.8333 5.48477 12.8486 2.5 9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333Z",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M17.5 17.5L13.875 13.875",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "send":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "Send"), /*#__PURE__*/_react.default.createElement("path", {
        d: "M18.3333 1.66669L9.16666 10.8334",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M18.3333 1.66669L12.5 18.3334L9.16666 10.8334L1.66666 7.50002L18.3333 1.66669Z",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "share-2":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width || 18,
        height: height || 19,
        viewBox: "0 0 18 19",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "Share"), /*#__PURE__*/_react.default.createElement("path", {
        d: "M13.5 6.5C14.7426 6.5 15.75 5.49264 15.75 4.25C15.75 3.00736 14.7426 2 13.5 2C12.2574 2 11.25 3.00736 11.25 4.25C11.25 5.49264 12.2574 6.5 13.5 6.5Z",
        stroke: color,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M4.5 11.75C5.74264 11.75 6.75 10.7426 6.75 9.5C6.75 8.25736 5.74264 7.25 4.5 7.25C3.25736 7.25 2.25 8.25736 2.25 9.5C2.25 10.7426 3.25736 11.75 4.5 11.75Z",
        stroke: color,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M13.5 17C14.7426 17 15.75 15.9926 15.75 14.75C15.75 13.5074 14.7426 12.5 13.5 12.5C12.2574 12.5 11.25 13.5074 11.25 14.75C11.25 15.9926 12.2574 17 13.5 17Z",
        stroke: color,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M6.4425 10.6325L11.565 13.6175",
        stroke: color,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M11.5575 5.38251L6.4425 8.36751",
        stroke: color,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "slash":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "Slash in Circle"), /*#__PURE__*/_react.default.createElement("path", {
        d: "M9.99999 18.3333C14.6024 18.3333 18.3333 14.6024 18.3333 9.99999C18.3333 5.39762 14.6024 1.66666 9.99999 1.66666C5.39762 1.66666 1.66666 5.39762 1.66666 9.99999C1.66666 14.6024 5.39762 18.3333 9.99999 18.3333Z",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M4.10834 4.10834L15.8917 15.8917",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "smartphone":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "Smartphone"), /*#__PURE__*/_react.default.createElement("path", {
        d: "M14.1667 1.66666H5.83335C4.91288 1.66666 4.16669 2.41285 4.16669 3.33332V16.6667C4.16669 17.5871 4.91288 18.3333 5.83335 18.3333H14.1667C15.0872 18.3333 15.8334 17.5871 15.8334 16.6667V3.33332C15.8334 2.41285 15.0872 1.66666 14.1667 1.66666Z",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M10 15H10.0088",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "star":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "Star"), /*#__PURE__*/_react.default.createElement("path", {
        d: "M9.99999 1.66666L12.575 6.88332L18.3333 7.72499L14.1667 11.7833L15.15 17.5167L9.99999 14.8083L4.84999 17.5167L5.83332 11.7833L1.66666 7.72499L7.42499 6.88332L9.99999 1.66666Z",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "tool":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width || 14,
        height: height || 14,
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "Tool"), /*#__PURE__*/_react.default.createElement("path", {
        d: "M8.38838 3.71741C8.27269 3.83544 8.20788 3.99413 8.20788 4.1594C8.20788 4.32467 8.27269 4.48336 8.38838 4.60139L9.39864 5.61165C9.51667 5.72734 9.67536 5.79215 9.84063 5.79215C10.0059 5.79215 10.1646 5.72734 10.2826 5.61165L12.6631 3.23122C12.9805 3.93284 13.0767 4.71456 12.9386 5.4722C12.8006 6.22984 12.4349 6.92742 11.8904 7.47197C11.3458 8.01653 10.6482 8.38219 9.8906 8.52024C9.13296 8.65828 8.35124 8.56215 7.64962 8.24465L3.28655 12.6077C3.03536 12.8589 2.69467 13 2.33943 13C1.98419 13 1.6435 12.8589 1.39231 12.6077C1.14112 12.3565 1 12.0158 1 11.6606C1 11.3054 1.14112 10.9647 1.39231 10.7135L5.75538 6.35041C5.43788 5.64879 5.34175 4.86707 5.4798 4.10943C5.61784 3.35179 5.9835 2.65421 6.52806 2.10965C7.07261 1.5651 7.77019 1.19944 8.52783 1.06139C9.28547 0.92335 10.0672 1.01948 10.7688 1.33698L8.39469 3.7111L8.38838 3.71741Z",
        stroke: color,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "trend-up":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "Trending Up"), /*#__PURE__*/_react.default.createElement("path", {
        d: "M19.1667 5L11.25 12.9167L7.08336 8.75L0.833359 15",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M14.1667 5H19.1667V10",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "tv":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "TV"), /*#__PURE__*/_react.default.createElement("path", {
        d: "M16.6667 5.83334H3.33335C2.41288 5.83334 1.66669 6.57954 1.66669 7.50001V16.6667C1.66669 17.5872 2.41288 18.3333 3.33335 18.3333H16.6667C17.5872 18.3333 18.3334 17.5872 18.3334 16.6667V7.50001C18.3334 6.57954 17.5872 5.83334 16.6667 5.83334Z",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M14.1666 1.66666L9.99998 5.83332L5.83331 1.66666",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "thumbs-up":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 17 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "Thumbs Up"), /*#__PURE__*/_react.default.createElement("path", {
        d: "M4.95841 14.6667H2.83341C2.45769 14.6667 2.09736 14.5262 1.83168 14.2762C1.566 14.0261 1.41675 13.687 1.41675 13.3334V8.66671C1.41675 8.31309 1.566 7.97395 1.83168 7.7239C2.09736 7.47385 2.45769 7.33337 2.83341 7.33337H4.95841M9.91675 6.00004V3.33337C9.91675 2.80294 9.69286 2.29423 9.29435 1.91916C8.89584 1.54409 8.35533 1.33337 7.79175 1.33337L4.95841 7.33337V14.6667H12.9484C13.2901 14.6703 13.6216 14.5576 13.8819 14.3494C14.1423 14.1411 14.3139 13.8513 14.3651 13.5334L15.3426 7.53337C15.3734 7.34228 15.3597 7.14716 15.3024 6.96154C15.2452 6.77592 15.1457 6.60424 15.011 6.45838C14.8762 6.31253 14.7094 6.196 14.522 6.11685C14.3347 6.03771 14.1313 5.99785 13.9259 6.00004H9.91675Z",
        stroke: color,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "user":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 26",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "User"), /*#__PURE__*/_react.default.createElement("path", {
        d: "M22.6667 25V22.3333C22.6667 20.9188 22.1048 19.5623 21.1046 18.5621C20.1044 17.5619 18.7478 17 17.3333 17H6.66667C5.25218 17 3.89562 17.5619 2.89543 18.5621C1.89524 19.5623 1.33333 20.9188 1.33333 22.3333V25",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M12.0001 11.6667C14.9456 11.6667 17.3334 9.27885 17.3334 6.33333C17.3334 3.38781 14.9456 1 12.0001 1C9.05453 1 6.66672 3.38781 6.66672 6.33333C6.66672 9.27885 9.05453 11.6667 12.0001 11.6667Z",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "user-plus":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 29 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "Add User"), /*#__PURE__*/_react.default.createElement("g", {
        clipPath: "url(#clip0_906_3818)"
      }, /*#__PURE__*/_react.default.createElement("path", {
        d: "M19.256 25.701V23.323C19.256 22.0617 18.755 20.852 17.8631 19.9601C16.9711 19.0682 15.7615 18.5671 14.5001 18.5671H6.17721C4.91585 18.5671 3.70616 19.0682 2.81425 19.9601C1.92234 20.852 1.42126 22.0617 1.42126 23.323V25.701",
        stroke: color,
        strokeWidth: strokeWidth || 2.37797,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M10.3386 13.8112C12.9653 13.8112 15.0946 11.6819 15.0946 9.05525C15.0946 6.42862 12.9653 4.29931 10.3386 4.29931C7.71201 4.29931 5.5827 6.42862 5.5827 9.05525C5.5827 11.6819 7.71201 13.8112 10.3386 13.8112Z",
        stroke: color,
        strokeWidth: strokeWidth || 2.37797,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M24.0118 10.2442V17.3781",
        stroke: color,
        strokeWidth: strokeWidth || 2.37797,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M27.5791 13.8112H20.4452",
        stroke: color,
        strokeWidth: strokeWidth || 2.37797,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
        id: "clip0_906_3818"
      }, /*#__PURE__*/_react.default.createElement("rect", {
        width: "28.5356",
        height: "28.5356",
        fill: "white",
        transform: "translate(0.232178 0.732178)"
      }))));
    case "users":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 17 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "Users"), /*#__PURE__*/_react.default.createElement("g", {
        clipPath: "url(#clip0_525_13085)"
      }, /*#__PURE__*/_react.default.createElement("path", {
        d: "M11.8346 14V12.6667C11.8346 11.9594 11.5537 11.2811 11.0536 10.781C10.5535 10.281 9.87521 10 9.16797 10H3.83464C3.12739 10 2.44911 10.281 1.94902 10.781C1.44892 11.2811 1.16797 11.9594 1.16797 12.6667V14",
        stroke: color,
        strokeWidth: strokeWidth || 1.2,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M6.4987 7.33333C7.97146 7.33333 9.16536 6.13943 9.16536 4.66667C9.16536 3.19391 7.97146 2 6.4987 2C5.02594 2 3.83203 3.19391 3.83203 4.66667C3.83203 6.13943 5.02594 7.33333 6.4987 7.33333Z",
        stroke: color,
        strokeWidth: strokeWidth || 1.2,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M15.832 14V12.6667C15.8316 12.0758 15.6349 11.5019 15.2729 11.0349C14.9109 10.5679 14.4041 10.2344 13.832 10.0867",
        stroke: color,
        strokeWidth: strokeWidth || 1.2,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M11.168 2.08667C11.7416 2.23354 12.25 2.56714 12.6131 3.03488C12.9761 3.50262 13.1732 4.07789 13.1732 4.67C13.1732 5.26212 12.9761 5.83739 12.6131 6.30513C12.25 6.77287 11.7416 7.10647 11.168 7.25334",
        stroke: color,
        strokeWidth: strokeWidth || 1.2,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
        id: "clip0_525_13085"
      }, /*#__PURE__*/_react.default.createElement("rect", {
        width: "16",
        height: "16",
        fill: "white",
        transform: "translate(0.5)"
      }))));
    case "video":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 17 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "Video"), /*#__PURE__*/_react.default.createElement("g", {
        clipPath: "url(#clip0_525_13091)"
      }, /*#__PURE__*/_react.default.createElement("path", {
        d: "M15.8346 4.6665L11.168 7.99984L15.8346 11.3332V4.6665Z",
        stroke: color,
        strokeWidth: strokeWidth || 1.2,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M9.83464 3.3335H2.5013C1.76492 3.3335 1.16797 3.93045 1.16797 4.66683V11.3335C1.16797 12.0699 1.76492 12.6668 2.5013 12.6668H9.83464C10.571 12.6668 11.168 12.0699 11.168 11.3335V4.66683C11.168 3.93045 10.571 3.3335 9.83464 3.3335Z",
        stroke: color,
        strokeWidth: strokeWidth || 1.2,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
        id: "clip0_525_13091"
      }, /*#__PURE__*/_react.default.createElement("rect", {
        width: "16",
        height: "16",
        fill: "white",
        transform: "translate(0.5)"
      }))));
    case "x-close":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "Close"), /*#__PURE__*/_react.default.createElement("path", {
        d: "M15 5L5 15",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M5 5L15 15",
        stroke: color,
        strokeWidth: strokeWidth || 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "x-octagon":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width || 22,
        height: height || 22,
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title !== "" && /*#__PURE__*/_react.default.createElement("title", null, title || "X"), /*#__PURE__*/_react.default.createElement("path", {
        d: "M6.86 1H15.14L21 6.86V15.14L15.14 21H6.86L1 15.14V6.86L6.86 1Z",
        stroke: color,
        strokeWidth: strokeWidth || 2,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M14 8L8 14",
        stroke: color,
        strokeWidth: strokeWidth || 2,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M8 8L14 14",
        stroke: color,
        strokeWidth: strokeWidth || 2,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
  }
}
GenericIcon.propTypes = {
  /**
   * Sets stroke color of icon
   */
  color: _propTypes.default.string,
  /**
   * Sets fill color of icon
   */
  fillColor: _propTypes.default.string,
  /**
   * Name of icon
   */
  icon: _propTypes.default.string.isRequired,
  /**
   * Sets width of icon
   */
  width: _propTypes.default.number,
  /**
   * Sets height of icon
   */
  height: _propTypes.default.number,
  /**
   * Sets stroke width of icon
   */
  strokeWidth: _propTypes.default.number,
  /**
   * Sets title of icon for accessibility
   */
  title: _propTypes.default.string
};
GenericIcon.defaultProps = {
  color: "#1a202c",
  // Orca Grey 8
  height: 20,
  width: 20
};
GenericIcon.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "GenericIcon",
  "props": {
    "color": {
      "defaultValue": {
        "value": "\"#1a202c\"",
        "computed": false
      },
      "description": "Sets stroke color of icon",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "height": {
      "defaultValue": {
        "value": "20",
        "computed": false
      },
      "description": "Sets height of icon",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "width": {
      "defaultValue": {
        "value": "20",
        "computed": false
      },
      "description": "Sets width of icon",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "fillColor": {
      "description": "Sets fill color of icon",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "icon": {
      "description": "Name of icon",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "strokeWidth": {
      "description": "Sets stroke width of icon",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "title": {
      "description": "Sets title of icon for accessibility",
      "type": {
        "name": "string"
      },
      "required": false
    }
  }
};